var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('span',[_vm._v(_vm._s(((_vm.date.getMonth() + 1) + "/" + (_vm.date.getDate()) + "/" + (_vm.date.getFullYear() - 2000) + " " + (_vm.getTime()))))]):_c('span',[_vm._v(_vm._s(_vm.dateStr))])}
var staticRenderFns = []

export { render, staticRenderFns }